import GigCardListings from '@fiverr-private/gig_listings/src/entries/GigCardListings';
import withGigsComponentWrapper from '../GigsComponentsWrapper';

const GigCardListingsWrapper = withGigsComponentWrapper(GigCardListings);

export default GigCardListingsWrapper;
